// Menu / catalog / filter action creators.
//
// Granular filter actions write to filterReducer. Prefer these over the legacy
// whole-blob `set_filters` (in action.js) so re-renders stay narrow.
//
// `set_selected_store` and `set_filter_category` also mirror into the legacy
// `appliedfilters` blob so screens that still read from reducer.js keep
// working during the migration.

import {
    FILTER_SET_SEARCH,
    FILTER_SET_DIETARY,
    FILTER_SET_SORT,
    FILTER_SET_CATEGORY,
    FILTER_SET_MASTER_CATEGORY,
    FILTER_SET_OPENED_INDEX,
    FILTER_SET_SELECTED_STORE,
    FILTER_RESET,
    FILTERS,
    CATALOG_LOAD_STORE,
    CATALOG_CLEAR_STORE,
    CATALOG_CLEAR_ALL,
} from '../action-types/menu-actions';

export const set_search_query = (searchQuery) => (dispatch) =>
    dispatch({ type: FILTER_SET_SEARCH, searchQuery });

export const set_dietary_filter = (dietaryFilter) => (dispatch) =>
    dispatch({ type: FILTER_SET_DIETARY, dietaryFilter });

export const set_sort_by = (sortBy) => (dispatch) =>
    dispatch({ type: FILTER_SET_SORT, sortBy });

export const set_filter_category = (category) => (dispatch, getState) => {
    dispatch({ type: FILTER_SET_CATEGORY, category });
    // Legacy mirror.
    const legacy = getState()?.reducer?.appliedfilters || {};
    dispatch({ type: FILTERS, appliedfilters: { ...legacy, category } });
};

export const set_master_category = (selectedMasterCategory) => (dispatch) =>
    dispatch({ type: FILTER_SET_MASTER_CATEGORY, selectedMasterCategory });

export const set_opened_index = (openedIndex) => (dispatch) =>
    dispatch({ type: FILTER_SET_OPENED_INDEX, openedIndex });

export const set_selected_store = (selected_store) => (dispatch, getState) => {
    dispatch({ type: FILTER_SET_SELECTED_STORE, selected_store });
    const legacy = getState()?.reducer?.appliedfilters || {};
    dispatch({
        type: FILTERS,
        appliedfilters: { ...legacy, selected_store, category: '' },
    });
};

export const reset_filters = () => (dispatch) =>
    dispatch({ type: FILTER_RESET });

// Dispatches catalog data grouped by store_id into catalogReducer.by_store.
// Any field omitted leaves the existing value in place.
export const catalog_load_store = ({
    store_id,
    items,
    categories,
    addons,
    labels,
    item_variants,
}) => (dispatch) => {
    dispatch({
        type: CATALOG_LOAD_STORE,
        store_id,
        items,
        categories,
        addons,
        labels,
        item_variants,
    });
};

export const catalog_clear_store = (store_id) => (dispatch) =>
    dispatch({ type: CATALOG_CLEAR_STORE, store_id });

export const catalog_clear_all = () => (dispatch) =>
    dispatch({ type: CATALOG_CLEAR_ALL });
